var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
export class MiniQuestionRewardScore {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get mini() {
        return this.parent;
    }
    get app() {
        return this.mini.app;
    }
    /* Scoring */
    get scoreTotal() {
        if (!this.mini.micro)
            return -9999;
        const totalScore = this.scoreLeastOftenShown + this.scoreSameStageType + this.scoreAlterSubtopic + this.scoreGradeCorridor + this.scoreRating + this.scorePreferVideo;
        return Math.round(totalScore);
    }
    get rewardTopic() {
        return this.mini.topic;
    }
    get scorePreferVideo() {
        // prefer Video
        if (this.mini.micro.subtopicName.includes("Video"))
            return 2000;
        return 0;
    }
    get scoreAlterSubtopic() {
        const { latest5MicroQuestions } = this.rewardTopic.topicFilter;
        if (latest5MicroQuestions.length === 0)
            return 0;
        let score = 0;
        const [first, second, third] = latest5MicroQuestions;
        if (first && first.subtopicName !== this.mini.micro.subtopicName)
            score += 300;
        if (second && second.subtopicName !== this.mini.micro.subtopicName)
            score += 200;
        if (third && third.subtopicName !== this.mini.micro.subtopicName)
            score += 100;
        return score;
    }
    get scoreRating() {
        return Math.round(this.mini.micro.rating * 1000);
    }
    get scoreGradeCorridor() {
        return 0;
        /*
        if (!this.mini.scoringStore.minGrade || !this.mini.scoringStore.maxGrade) return 0;
    
        if (this.app.cycle.cycleGrade.currentGradeNumeric < this.mini.scoringStore.minGrade) {
          return -1000000;
        }
        if (this.app.cycle.cycleGrade.currentGradeNumeric > this.mini.scoringStore.maxGrade) {
          return -1000000;
        }
        return 0;*/
    }
    get scoreLeastOftenShown() {
        if (this.mini.miniPassState.questionState === QuestionPassStateId.New)
            return 100000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed)
            return 10000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed2)
            return 5000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed3)
            return 0;
        return 0;
    }
    get scoreSameStageType() {
        if (this.mini.micro.layoutName.includes('Abfrager')) {
            return -5000;
        }
        return 0;
    }
}
__decorate([
    computed
], MiniQuestionRewardScore.prototype, "scoreTotal", null);
